import React from 'react';
import { useEnrollees } from './use-enrollees';
import { EnrolleeItem } from './enrollee-item'; 

export const EnrolleesList = ({ courseId }) => {
    const { students } = useEnrollees({ courseId  });

    const renderEnrollee = (enrollee) => (
        <EnrolleeItem
            courseId={courseId}
            enrollee={enrollee}
            key={enrollee.id}
        />
    );

    return (
        <div
            style={{
                padding: '10px',
                overflowY: 'auto',
                height: '400px',
                gap: '10px',
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            {students.map(renderEnrollee)}
        </div>
    );
};
